import React from 'react'
import styled from 'styled-components/macro'

const OllieStarterPrompts = ({
  prompts = [],
  onSelect,
  disabled = false,
  label = 'Try asking',
}) => {
  if (!prompts.length) {
    return null
  }

  return (
    <Wrapper>
      <Label>{label}</Label>
      <PromptList>
        {prompts.map(prompt => (
          <PromptButton
            key={prompt}
            type='button'
            disabled={disabled}
            onClick={() => onSelect(prompt)}
          >
            {prompt}
          </PromptButton>
        ))}
      </PromptList>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 12px;
`

const Label = styled.p`
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const PromptList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const PromptButton = styled.button`
  text-align: left;
  border: 1px solid ${({ theme }) => theme.colours.panSilver};
  background: ${({ theme }) => theme.colours.mayoWhite};
  color: ${({ theme }) => theme.colours.bbqBlack};
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colours.lettuceGreen};
    background: ${({ theme }) => theme.colours.bgGrey};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`

export default OllieStarterPrompts
